// Convert any date input to YYYY-MM-DD (for input fields like <input type="date">)
export const toDateInputFormat = (input) => {
  if (!input) return '';

  try {
    // If it's already in DD-MM-YYYY format
    if (/^\d{2}-\d{2}-\d{4}$/.test(input)) {
      const [dd, mm, yyyy] = input.split('-');
      return `${yyyy}-${mm}-${dd}`;
    }

    // If it's in ISO or any valid date string
    const date = new Date(input);
    if (!isNaN(date)) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }

    // If all fails
    return '';
  } catch (err) {
    console.error('Invalid date input:', input);
    return '';
  }
};

// Convert YYYY-MM-DD to DD-MM-YYYY (for display)
export const toDisplayFormat = (input) => {
  if (!input) return '';

  try {
    // If input is in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [yyyy, mm, dd] = input.split('-');
      return `${dd}-${mm}-${yyyy}`;
    }

    // If it's a valid Date object or ISO string
    const date = new Date(input);
    if (!isNaN(date)) {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    }

    // If all fails
    return '';
  } catch (err) {
    console.error('Invalid date format:', input);
    return '';
  }
};
